// @ts-nocheck
import { FETCH_ACTIVITIES_FULFILLED, FETCH_ACTIVITIES_REJECTED } from './activityActionTypes';

const initialState = {
  activities: null,
};

export default function activityReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_ACTIVITIES_FULFILLED:
      return {
        ...state,
        activities: action.payload,
      };
    case FETCH_ACTIVITIES_REJECTED:
      return {
        ...state,
        activities: null,
      };
    default:
      return state;
  }
}
